export default async () => {
	/*-------- Modals --------*/
	const { default: Overlay } = await import('@components/overlays')

	document.querySelectorAll('.modal').forEach(item => new Overlay(item))

	/*-------- Menu --------*/
	const menuWrapper = document.querySelector('.menu-wrapper')
	const menuToggle = document.querySelector('.menu-toggle')

	if (menuWrapper && menuToggle) {
		const { default: Menu } = await import('@components/menu')

		new Menu(menuWrapper, menuToggle)
	}

	/*-------- Submenus --------*/
	const submenus = document.querySelectorAll('.submenu')

	if (submenus.length) {
		const { default: Submenu } = await import('@components/submenus')

		submenus.forEach(submenu => new Submenu(submenu, submenu.previousElementSibling))

		addEventListener('opening', e => {
			if (e.target.classList.contains('submenu')) {
				document.body.style.setProperty('--submenu-h', `${e.target.offsetHeight}px`)
			}
		})

		addEventListener('closing', e => {
			if (e.target.classList.contains('submenu')) {
				document.body.style.setProperty('--submenu-h', '')
			}
		})
	}

	/*-------- Optimise vh on mobile --------*/
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	/*-------- Show rs --------*/
	if ($(".anim_link").length) {
		$('.anim_link').click(function () {
			$(this).find('.text').fadeOut(0);
			$(this).find('.link').fadeIn(0);
		});
	}

	/*
	|
	| Swiper news
	|-----------
	*/
	const { default: Swiper, Navigation } = await import('swiper');
	Swiper.use([Navigation]);

	if ($(".swiper-news").length) {
		const swipernews = new Swiper(".swiper-news", {
			slidesPerView: 1.5,
			spaceBetween: 30,
			speed: 1000,
			centeredSlides: true,
			breakpoints: {
				0: {
					slidesPerView: 1.2,
				},
				768: {
					slidesPerView: 1.2,
					spaceBetween: 16
				},
				1200: {
					slidesPerView: 1.5
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		});
	}


	/*
	|
	| Swiper Quote
	|-----------
	*/
	if ($(".swiper-quote").length) {
		const swipernews = new Swiper(".swiper-quote", {
			slidesPerView: 1,
			spaceBetween: 30,
			speed: 1000,
			centeredSlides: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		});
	}

	/*
	|
	| Swiper numbers
	|-----------
	*/

	if ($(".swiper-numbers").length) {
		const swipernews = new Swiper(".swiper-numbers", {
			slidesPerView: 1,
			speed: 1000,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		});
	}

	/*	
	|
	| Plyr
	|-----------------
	*/
	if ($(".videoyt").length) {
		const { default: Plyr } = await import('@components/plyr.min');
		const $customPlyrVideo = jQuery('.custom-plyr-video');
	
		$.each($customPlyrVideo, function () {
			const $video = $(this);
			const $videoPoster = $video.find('.item-poster');
			const iframeHtml = $video.data('id'); // Contient le HTML de l'iframe
			const videoId = extractYouTubeId(iframeHtml); // Extrait l'ID de la vidéo
	
			console.log("Extracted YouTube ID:", videoId);
	
			if (!videoId) {
				console.error("Invalid YouTube iframe:", iframeHtml);
				return; // Ignorer si l'ID est invalide
			}
	
			// Ajouter dynamiquement un iframe
			const iframe = document.createElement('iframe');
			iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoId}?enablejsapi=1`);
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
			iframe.setAttribute('allowfullscreen', '');
			iframe.style.width = '100%';
			iframe.style.height = '100%';
			$video.append(iframe);
	
			// Initialisation avec Privacy Enhanced Mode et couverture
			let player = new Plyr(iframe, {
				youtube: {
					noCookie: true
				},
				poster: $videoPoster.css('background-image').replace(/url\(['"]?(.*?)['"]?\)/i, '$1') // Extrait l'image de couverture
			});
	
			console.log("Plyr instance:", player);
	
			// Gestion de l'événement "play" pour masquer l'afficheur
			player.on("play", () => {
				$videoPoster.css('opacity', '0');
			});
		});
	}
	
	function extractYouTubeId(url) {
		const regex = /(?:youtube\.com\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]+)/;
		const match = url.match(regex);
		return match ? match[1] : null;
	}
	
		

	/*	
	|
	| Show search
	|-----------------
	*/
	if ($(".btn-search").length) {
		$('.btn-search .glass').click(function () {
			$('.form-search').fadeIn();
			$(this).hide();
			$('.btn-search .cross').show();
		});

		$('.btn-search .cross').click(function () {
			$('.form-search').fadeOut();
			$(this).hide();
			$('.btn-search .glass').show();
		});

		$('.btn-search .cross').hide();
	}

	/*	
	|
	| Animation Lotti
	|-----------------
	*/
	if ($(".anim-lotti").length) {
		$('.anim-lotti').each(function () {
			var animationPath = $(this).data('lottie');
			lottie.loadAnimation({
				container: this,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: animationPath,
				rendererSettings: {
					preserveAspectRatio: 'xMidYMid meet' // Garde les proportions tout en étant responsive
				}
			});
		});
	}


	
} 